import axios from "axios";
import segment from "../../models/gestionTiempos/segment";
import numSequence from "../../models/gestionTiempos/numSequence";
import schedule from "../../models/gestionTiempos/schedules/schedule";
import employedSchedule from "../../models/gestionTiempos/schedules/employedSchedule";
import groupSchedule from "../../models/gestionTiempos/schedules/groupSchedule";
import moment from "moment";
import scheduleElement from "../../models/gestionTiempos/scheduleElement";
import stateDay from "../../models/gestionTiempos/stateDay";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getSchedule() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios.get(`${url}/horarios`, { headers }).then(({ data }) =>
      data.map((item) => {
        return schedule.fromJson(item);
      }),
    );
  }
  getSegment(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let horarioId = data;

    return axios
      .get(`${url}/segmhorario/${horarioId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return segment.fromJson(item);
        }),
      );
  }
  getNumberSec(horarioId, segmid) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/numsecuencia/${horarioId}&${segmid}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return numSequence.fromJson(item);
        }),
      );
  }

  new = (data) => {
    let token = localStorage.getItem("token");
    let empId = parseInt(localStorage.getItem("empId"), 10);
    let operId = parseInt(localStorage.getItem("operId"), 10);
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    let payload = {
      empId: empId,
      fecha: data.date + "T00:00:00.000Z",
      desde: data.from + "T00:00:00.000Z",
      hasta:
        data.to && (typeof data.haNoEx === "undefined" || !data.haNoEx)
          ? moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z"
          : undefined,
      haNoEx: data.haNoEx,
      operId: operId,
      horarioId: data.schedule,
      segmId: data.initialSegment,
      numSecuencia: data.sequenceNumber,
      segmDespl: data.initialDay,
    };

    return axios.post(`${url}/emphorario/emps`, payload, { headers });
  };
  getEmployedSchedule() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = localStorage.getItem("empId");

    return axios
      .get(`${url}/emphorario/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return employedSchedule.fromJson(item);
        }),
      );
  }
  getGroupSchedule() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let empId = localStorage.getItem("empId");

    return axios
      .get(`${url}/emphorario/grupos/${empId}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return groupSchedule.fromJson(item);
        }),
      );
  }
  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    const horarioid = data.id;
    const fecdesde = data.from;

    return axios.delete(`${url}/emphorario/${empId}&${horarioid}&${fecdesde}`, {
      headers,
    });
  };
  edit = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      fecha: moment().format("YYYY-MM-DD") + "T00:00:00.000Z",
      segmId: data.initialSegment,
      numSecuencia: data.sequenceNumber,
      segmDespl: data.initialDay,
      desde: data.from + "T00:00:00.000Z",
    };
    if (data.haNoEx) {
      payload = {
        ...payload,
        haNoEx: data.haNoEx,
      };
    } else if (data.to && !data.haNoEx) {
      payload = {
        ...payload,
        hasta: moment(data.to).format("YYYY-MM-DD") + "T00:00:00.000Z",
      };
    }

    const empId = localStorage.getItem("empId");
    let desde = data.fromOld;
    return axios
      .patch(`${url}/emphorario/${empId}&${data.nameId}&${desde}`, payload, {
        headers,
      })
      .then(() => {});
  };
  getScheduleElement(id) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };

    const segment = id;

    return axios
      .get(`${url}/segmelem/eleminfo/${segment}`, { headers })
      .then(({ data }) =>
        data.map((item) => {
          return scheduleElement.fromJson(item);
        }),
      );
  }
  getStateDay(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios
      .get(`${url}/estadodia/${data.empId}&${data.date}`, { headers })
      .then(({ data }) => {
        return stateDay.fromJson(data);
      });
  }
}
export default service;
